import { render } from "./CtaButton.vue?vue&type=template&id=acb5d672&scoped=true"
import script from "./CtaButton.vue?vue&type=script&lang=js"
export * from "./CtaButton.vue?vue&type=script&lang=js"

import "./CtaButton.vue?vue&type=style&index=0&id=acb5d672&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb5d672"]])

export default __exports__